import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { admin } from "@/lib/api";

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(null);

  const check = useCallback(async () => {
    try {
      await admin.me();
      setAuthed(true);
    } catch {
      setAuthed(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (password) => {
    await admin.login(password);
    setAuthed(true);
  };
  const logout = async () => {
    try { await admin.logout(); } finally { setAuthed(false); }
  };

  return <Ctx.Provider value={{ authed, login, logout, setAuthed, recheck: check }}>{children}</Ctx.Provider>;
};

export const useAdminAuth = () => useContext(Ctx);
